import { render, staticRenderFns } from "./SwitchingSettingUser.vue?vue&type=template&id=2eb3a5eb&"
import script from "./SwitchingSettingUser.vue?vue&type=script&lang=js&"
export * from "./SwitchingSettingUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports